query BrTermsOfAdhesionOffline($input: GetBrTermsOfAdhesionOfflineInput!) {
  brTermsOfAdhesion: getBrTermsOfAdhesionOffline(input: $input) {
    id
    pendingSignatureDownloadUrl
    pendingSignatureViewUrl: pendingSignatureDownloadUrl(viewInline: true)
    brPowerPlan {
      id
      discountRate
    }
    brConsumerUnit {
      id
      name
      consumerUnitCode
      currentDiscountRate
      utilityCompany {
        id
        name
      }
      brCustomer {
        id
        name
        type
        cpf
        cnpj
        salesPartnerDonationRate
        primaryBrContact {
          id
          fullName
          cpf
        }
      }
    }
  }
}
